if (!process.env.TELEGRAM_BOT_USERNAME) throw new Error('TELEGRAM_BOT_USERNAME is not specified');

export const Const = {
    TELEGRAM_BOT_USERNAME: process.env.TELEGRAM_BOT_USERNAME,

    /** Домен */
    PROJECT_DOMAIN: process.env.NODE_ENV === 'production' ? 'rent.longpoll.ru' : 'rent-beta.longpoll.ru',
};
